import type { DefaultValues, UseFormReturn } from 'react-hook-form';
import { Labeled, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IAppRegion } from '~/lib/appSettings';
import type { IInvitationResponseFormValues } from './InvitationResponseForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { AppRegionSelector } from '~/components/organisms/fields/AppRegionSelector';

export type IAppFormChallengeMainProps = IContainerProps & {
  form: UseFormReturn<IInvitationResponseFormValues>;
  defaultValues?: DefaultValues<IInvitationResponseFormValues>;
  appRegion: IAppRegion;
};

export const InvitationResponseFormMainSection: React.FC<
  IAppFormChallengeMainProps
> = (props) => {
  const { sx, form, defaultValues, appRegion } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled
        label={t('InvitationResponseFormMainSection.challengeCode')}
        required
        readOnly={defaultValues?.challengeCode !== undefined}
      >
        <FormField
          name="challengeCode"
          control={form.control}
          as={TextInputField}
          forwardError
        />
      </Labeled>
      <Labeled label={t('common.region')} required readOnly>
        {(elementProps) => (
          <AppRegionSelector defaultValue={appRegion} {...elementProps} />
        )}
      </Labeled>
    </FormSection>
  );
};
